import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Collapse, Table, Typography, Button, Card, message } from "antd";
import moment from "moment";
import api from "Common/Client/Interceptor";
const { Panel } = Collapse;
const { Title, Text } = Typography;
const CourseItems = () => {
  const downloadCourseItemFile = async (courseItemId, fileName) => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get(
        `/Library/Download-CourseItem-File?courseItemId=${courseItemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      message.error('Failed')
    }
  };
  const location = useLocation();
  const navigate = useNavigate();
  const { courseFiles, courseTitle, courseDescription } = location.state || {};
  // Define content types and their labels
  const allTypes = ["Video", "Content"];
  const getTypeLabel = (contentType) => {
    switch (contentType) {
      case 5:
        return "Content";
      case 6:
        return "Video";
    }
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "File Type",
      dataIndex: "contentType",
      key: "contentType",
      render: (contentType) => getTypeLabel(contentType),
    },
    {
      title: "Uploaded On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => moment(text).format("MMM D, YYYY h:mm A"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <a
          onClick={() => downloadCourseItemFile(record.id, record.fileName)}
          style={{ cursor: "pointer", color: "#1890ff" }}
        >
          Download File
        </a>
      ),
    },
  ];
  return (
    <Card
      title="Course Item"
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
      className="card-professional"
    >
      <Title level={4}>{courseTitle}</Title>
      {courseDescription && (
        <Text style={{ display: "block", marginBottom: 24 }}>{courseDescription}</Text>
      )}
      {/* Course Files Table */}
      <Collapse accordion>
        {allTypes.map((type, index) => {
          const typeData =
            courseFiles?.filter((file) => getTypeLabel(file.contentType) === type) || [];
          return (
            <Panel key={index} header={<span style={{ fontWeight: 500 }}>{type}</span>}>
              <Table
                columns={columns}
                dataSource={typeData}
                pagination={false}
                rowKey="id"
                locale={{ emptyText: `No ${type} available.` }}
              />
            </Panel>
          );
        })}
      </Collapse>
    </Card>
  );
};
export default CourseItems;
